<template>
  <donut-chart89-template
    :board-ids="[518]"
    :data-type="dataType"
    :graph-id="89"
    date-field="$.body.inputA_3"
    :count-fields="['body.inputA_7']"
    title="작업환경측정결과 현황"
    unit="건"/>
</template>
<script>
/* eslint-disable brace-style */
import DonutChart89Template from "@/views/graph/DonutChart89Template.vue";

export default {
  name: 'DonutChart89',
  components: {DonutChart89Template},
  props: {
    dataType: 'detail' | 'field' | 'company' | 'project',
  },
}
</script>

<style scoped>

</style>
